import FinancingCostRuleService from '@/services/admin/FinancingCostRuleService'

import { FINANCING_COST_PROPERTY_TYPE } from '@/constants/financingCostPropertyType'

export const namespaced = true

export const state = {
  conditions: {}
}

export const mutations = {
  SET_CONDITIONS(state, values) {
    state.conditions = Object.assign({}, state.conditions, values)
  }
}

export const actions = {
  getConditions({ commit, getters, state }, conditions) {
    let dontSetConditionByTypeAndId = {
      type: FINANCING_COST_PROPERTY_TYPE.CREDIT_TYPE,
      id: 38
    }
    return new Promise(resolve => {
      FinancingCostRuleService.getConditions(conditions).then(response => {
        response.data[dontSetConditionByTypeAndId.type] = response.data[dontSetConditionByTypeAndId.type].filter(
          item => item.id !== dontSetConditionByTypeAndId.id
        )
        commit('SET_CONDITIONS', response.data)
        resolve(response.data)
      })
    })
  }
}
